import { render, staticRenderFns } from "./IdleForm.vue?vue&type=template&id=270df6d7&scoped=true"
import script from "./IdleForm.vue?vue&type=script&lang=js"
export * from "./IdleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270df6d7",
  null
  
)

export default component.exports